module.exports = __webpack_public_path__ + "static/img/wjtb_doc.d935ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wjtb_doc.png
// module id = XdSl
// module chunks = 181